import { fromJS } from 'immutable';
import * as arbitratorActions from '../actions/arbitrator';
import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import { fetchingState, defaultPageSize } from '@constants';

const initialStats = {
  fields: {},
  searchOptions: {},
  arbitratorList: {
    pageSize: defaultPageSize,
    sortModel: [],
    currentPage: 0,
    totalCount: 0,
  },
  arbitrator: {},
  arbitrators: {},
  searchArbitrators: {},
  newArbitrator: {},
  notes: {},
  arbitratorLookupModal: {
    open: false,
    mode: null,
    state: '',
    data: [],
    selection: [],
    count: 0,
  },
  arbitratorCreateModal: {
    open: false,
    state: '',
    data: {},
  },
  activeArbitrator: null,
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case arbitratorActions.ARBITRATOR_SEARCH_OPTIONS_FETCH_START:
      return state.setIn(['searchOptions', 'state'], fetchingState.FETCHING);
    case arbitratorActions.ARBITRATOR_SEARCH_OPTIONS_FETCH_SUCCESS:
      let newState = state.setIn(
        ['searchOptions', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['searchOptions', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case arbitratorActions.ARBITRATOR_SEARCH_OPTIONS_FETCH_ERROR:
      return state.setIn(['searchOptions', 'state'], fetchingState.ERROR);

    case arbitratorActions.ARBITRATOR_FIELDS_FETCH_START:
      return state.setIn(['fields', 'state'], fetchingState.FETCHING);
    case arbitratorActions.ARBITRATOR_FIELDS_FETCH_SUCCESS:
      newState = state.setIn(['fields', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['fields', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case arbitratorActions.ARBITRATOR_FIELDS_FETCH_ERROR:
      return state.setIn(['fields', 'state'], fetchingState.ERROR);

    case arbitratorActions.ARBITRATOR_SEARCH_START:
      return state.setIn(['arbitratorList', 'state'], fetchingState.FETCHING);
    case arbitratorActions.ARBITRATOR_SEARCH_SUCCESS:
      newState = state.setIn(['arbitratorList', 'state'], fetchingState.LOADED);
      newState = newState.setIn(
        ['arbitratorList', 'totalCount'],
        action.data && action.data.totalArbitrator
          ? action.data.totalArbitrator.count
          : 0,
      );
      return newState.setIn(
        ['arbitratorList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case arbitratorActions.ARBITRATOR_SEARCH_ERROR:
      return state.setIn(['arbitratorList', 'state'], fetchingState.ERROR);
    case arbitratorActions.ARBITRATOR_DELETE_SUCCESS:
      return state.setIn(
        ['arbitratorList', 'data'],
        fromJS(
          state
            .getIn(['arbitratorList', 'data'])
            .toJS()
            .filter(d => d.arbitratorID !== action.arbitratorID),
        ),
      );

    case arbitratorActions.ARBITRATOR_CHANGE_CURRENT_PAGE:
      return state.setIn(['arbitratorList', 'currentPage'], action.data);
    case arbitratorActions.ARBITRATOR_CHANGE_PAGE_SIZE:
      return state.setIn(['arbitratorList', 'pageSize'], action.data);
    case arbitratorActions.ARBITRATOR_CHANGE_SORT_MODEL:
      return state.setIn(['arbitratorList', 'sortModel'], fromJS(action.data));

    case arbitratorActions.ARBITRATOR_FETCH_START:
      return state.setIn(['arbitrator', 'state'], fetchingState.FETCHING);
    case arbitratorActions.ARBITRATOR_FETCH_SUCCESS:
      newState = state.setIn(['arbitrator', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['arbitrator', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case arbitratorActions.ARBITRATOR_FETCH_ERROR:
      return state.setIn(['arbitrator', 'state'], fetchingState.ERROR);

    case arbitratorActions.ARBITRATOR_NOTES_FETCH_START:
      return state.setIn(['notes', 'state'], fetchingState.FETCHING);
    case arbitratorActions.ARBITRATOR_NOTES_FETCH_SUCCESS:
      newState = state.setIn(['notes', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['notes', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case arbitratorActions.ARBITRATOR_NOTES_FETCH_ERROR:
      return state.setIn(['notes', 'state'], fetchingState.ERROR);

    case arbitratorActions.ARBITRATOR_UPDATE_START:
      return state.setIn(['arbitrator', 'state'], fetchingState.SAVING);
    case arbitratorActions.ARBITRATOR_UPDATE_ERROR:
      return state.setIn(['arbitrator', 'state'], fetchingState.ERROR);
    case arbitratorActions.ARBITRATOR_UPDATE_SUCCESS:
      newState = state.setIn(['arbitrator', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['arbitrator', 'data'],
        fromJS(action.data.results[0]),
      );
    case arbitratorActions.ARBITRATOR_RESET_DATA:
      return state.setIn(['arbitrator'], fromJS({}));
    case arbitratorActions.ARBITRATOR_CREATE[START]:
      return state.setIn(['arbitrator', 'state'], fetchingState.SAVING);
    case arbitratorActions.ARBITRATOR_CREATE[SUCCESS]:
      newState = state.setIn(['arbitrator', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['arbitrator', 'data'],
        fromJS(action.data.results[0]),
      );
    case arbitratorActions.ARBITRATOR_CREATE[ERROR]:
      return state.setIn(['arbitrator', 'state'], fetchingState.ERROR);
    case arbitratorActions.ARBITRATOR_VALIDATE_SUCCESS:
      return state.setIn(
        ['arbitrator', 'data'],
        fromJS(action.data.results[0]),
      );

    case arbitratorActions.ARBITRATOR_NOTE_ADD_SUCCESS:
      let newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.concat(action.data.results);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case arbitratorActions.ARBITRATOR_NOTE_DELETE_SUCCESS:
      newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.filter(n => n.noteID !== action.noteId);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case arbitratorActions.ARBITRATOR_NOTE_UPDATE_SUCCESS:
      newNotes = state.getIn(['notes', 'data']).toJS();
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case arbitratorActions.OPEN_ARBITRATOR_LOOKUP_MODAL:
      return state.set(
        'arbitratorLookupModal',
        fromJS({
          open: true,
          mode: action.payload,
          state: '',
          data: [],
          selection: [],
        }),
      );

    case arbitratorActions.LOOKUP_ARBITRATOR[START]:
      return state.setIn(
        ['arbitratorLookupModal', 'state'],
        fetchingState.FETCHING,
      );

    case arbitratorActions.LOOKUP_ARBITRATOR[SUCCESS]:
      console.log(action);
      return state
        .setIn(['arbitratorLookupModal', 'state'], fetchingState.LOADED)
        .setIn(
          ['arbitratorLookupModal', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['arbitratorLookupModal', 'count'],
          action.data && action.data.totalArbitrator
            ? action.data.totalArbitrator['COUNT(*)']
            : 0,
        );

    case arbitratorActions.LOOKUP_ARBITRATOR[ERROR]:
      return state.setIn(
        ['arbitratorLookupModal', 'state'],
        fetchingState.ERROR,
      );

    case arbitratorActions.CLOSE_ARBITRATOR_LOOKUP_MODAL:
      return state.setIn(['arbitratorLookupModal', 'open'], false);

    case arbitratorActions.MODAL_SELECT_ARBITRATOR_RECORDS:
      return state.setIn(
        ['arbitratorLookupModal', 'selection'],
        action.payload,
      );
    case arbitratorActions.SET_ACTIVE_ARBITRATOR: {
      return state.setIn(['activeArbitrator'], action.payload);
    }
    case arbitratorActions.RESET_ACTIVE_ARBITRATOR: {
      return state.setIn(['activeArbitrator'], null);
    }
    case arbitratorActions.OPEN_ARBITRATOR_CREATE_MODAL:
      return state.set(
        'arbitratorCreateModal',
        fromJS({
          open: true,
          state: '',
        }),
      );

    case arbitratorActions.CLOSE_ARBITRATOR_CREATE_MODAL:
      return state.setIn(['arbitratorCreateModal', 'open'], false);

    case arbitratorActions.RESET_ARBITRATOR_CREATE_MODAL:
      return state
        .setIn(['arbitratorCreateModal', 'data'], fromJS({}))
        .setIn(['arbitratorCreateModal', 'state'], '');

    case arbitratorActions.ARBITRATOR_CREATE_MODAL_RESULT:
      return state.setIn(
        ['arbitratorCreateModal', 'data'],
        fromJS(action.data || {}),
      );
    default:
      return state;
  }
};
